import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { SystemTransferTypes } from './systemTransfer.types';
const getPointsTransfer = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<SystemTransferTypes[]>>('/systemTransfer')).data;
};

export const systemTransferQueries = {
  all: () => ['systemTransfer'],

  list: () =>
    queryFactoryOptions<ApiResponse<SystemTransferTypes[]>>({
      queryKey: [...systemTransferQueries.all(), 'list'],
      queryFn: (client) => getPointsTransfer(client),
    }),
};
